import HeroPanel from "./hero.js"

export default HeroPanel
